import React from 'react';
import NavigationBar from './pages/NavigationBar';
// import NavigationBar_ from './pages/NavigationBar_';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style_module.css';
import './index.css';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import PLMNSelection from './pages/lte_commands/at_cops';

const MEASUREMENT_ID = "G-0Q53EHBML6";

ReactGA.initialize(MEASUREMENT_ID);

export default function MyApp() {
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname });
      }, []);
    return (
        <div className="app">
            <NavigationBar />
        </div>           
    );
  }
